import ComparisonOperators from "../../consts/DataSourceModule/ComparisonOperators";
import FilterParameterDto from "./FilterParameterDto";

class FilterParameterValueDto extends FilterParameterDto {
    Value: string;

    constructor(id: number, fieldReferenceId: number, operator: ComparisonOperators, value: string) {
        super(id, fieldReferenceId, operator);
        this.Value = value;
    }
}

export default FilterParameterValueDto;
